// Fingerprint of one phone contact — MUST stay identical to the API's copy in
// mehfil-nodejs/api/new/contactHash.js (incremental "Sync my contacts": the
// phone compares its contacts with the server's fingerprints and uploads only
// new / changed ones). Texts trimmed + cut to the column sizes, numbers reduced
// to their last 10 digits, de-duplicated (first label wins) and sorted.

const t = (v, n) => String(v == null ? '' : v).trim().slice(0, n);
const ten = (v) => { const d = String(v == null ? '' : v).replace(/\D/g, ''); return d.length > 10 ? d.slice(-10) : d; };

export function canonical(c) {
  const seen = new Set();
  const nums = [];
  for (const x of (c && c.Numbers) || []) {
    const n = ten(x && x.Number);
    if (!n || seen.has(n)) continue;
    seen.add(n);
    nums.push(n + '=' + t(x && x.Label, 50));
  }
  nums.sort();
  return [
    t(c.DisplayName, 150), t(c.GivenName, 100), t(c.MiddleName, 100), t(c.FamilyName, 100),
    t(c.Organization, 150), t(c.EmailId, 150), nums.join(';'),
  ].join('|');
}

// FNV-1a, 32 bit, over UTF-16 code units → 8 hex chars.
function fnv1a(str) {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h.toString(16).padStart(8, '0');
}

export const contactHash = (c) => fnv1a(canonical(c));
